import { WaitLoadingService } from './../components/common/waitLoading/wait-loading.service';
import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnDestroy,
  ElementRef,
  OnInit,
  AfterContentInit
} from '@angular/core';
import { CompanyDTO } from '../api/plyca-dtos-v2';
import { Configuration } from '../conf/app.constants';
import { FormConfig } from '../components/forms/form.objects';
import { formPlycaComponent } from '../components/forms/formPlyca.component';
import * as lodash from 'lodash';
import { UIService, generateRandomIdentifier } from '../ui.service';
import { tap, finalize, catchError, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

export class ViewDTOModal {
  constructor(
    public companyDTO: CompanyDTO,
    public resourceJson: String
  ) {


  }
}
import { CompanyService } from './company.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { HelpService, HelpType } from '../components/common/help/help.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { throwError } from 'rxjs';
import { UserService } from '../user.service';
import { ServiceLocator } from '../ServiceLocator';
import { ConfirmationService } from 'primeng-lts/api';


@Component({
  selector: 'plyca-companyAdmin',
  templateUrl: 'companyAdmin.template.html',
  providers: [DialogService, CompanyService]
})
export class CompanyAdminComponent extends BaseComponent implements OnInit, OnDestroy, AfterContentInit {


  locale: string;
  companyDTO: CompanyDTO;
  editing = false;
  formConfig: FormConfig;
  resourceJson: string;
  tagsParent: string[] = [];
  windowHash: string;
  loaded = false;


  @ViewChild('formContainer', { read: ViewContainerRef, static: true })
  formContainer: ViewContainerRef;
  form: formPlycaComponent;
  esAltaEmpresa = false;
  readOnly = false;
  //private properties = {};
  public translateService: TranslateService;

  constructor(
    public uiService: UIService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public companyService: CompanyService,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    protected configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef,
    private waitService: WaitLoadingService,
    private userService: UserService,
    private confirmationService: ConfirmationService

  ) {
    super();
    this.translateService = ServiceLocator.injector.get(TranslateService);
    // Se recoge la ayuda de la pantalla que abri� la edici�n de empresa
    // y se establece la ayuda de la edici�n
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => this.tagsParent = helpTags)));
    /*this.subscribe(
      forkJoin([
        // com.nexusit.integraciones.terceros.logica.ConstantesIntegracionTerceros
        //SincronizacionTercerosActivo = "SincronizacionTerceros.Activo"
        //SincronizacionTercerosFraMtoEmpresaPublicarAlCrearTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlCrearTercero.Activo";
        //SincronizacionTercerosFraMtoEmpresaPublicarAlModificarTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlModificarTercero.Activo";
        //String SincronizacionTercerosFraMtoEmpresaPublicarAlEliminarTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlEliminarTercero.Activo";
        this.propertyService.getProperty('SincronizacionTerceros.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlCrearTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlModificarTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlEliminarTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))

      ]).pipe(
        map(
          (prop: any[]) => {
            this.properties['SincronizacionTerceros_Activo'] = prop[0] == '1';
            this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlCrearTercero_Activo'] = prop[1] == '1';
            this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlModificarTercero_Activo'] = prop[2] == '1';
            this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlEliminarTercero_Activo'] = prop[3] == '1';
          }),
        finalize(() => {

        })
      )
    )*/
  }
  ngAfterContentInit(): void {
    if (this.elem) {
      this.elem.nativeElement.focus();
    }
    // carga de acciones
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.editMode();
  }

  ngOnInit() {
    this.waitService.startWaiting();
    this.init();
  }

  init(): void {

    this.companyDTO = this.dialogConfig['item'].companyDTO;
    this.esAltaEmpresa = this.dialogConfig['esAltaEmpresa'];
    this.readOnly = this.dialogConfig['readOnly'];

    this.windowHash = generateRandomIdentifier();


    this.resourceJson = this.dialogConfig['item'].resourceJson;

    this.selectCompany(this.resourceJson);
    if (this.esAltaEmpresa) {
      this.companyDTO['externalIdentifierTempDescription'] = 'n/d';
    }
  }

  selectCompany(resourceJson: string) {
    this.formConfig = new FormConfig(undefined,
      resourceJson,
      this.companyDTO
    );
    this.formConfig.functions.push({
      identifier: 'isEditing',
      fn: this.isEditing.bind(this)
    });
    this.formConfig.functions.push({
      identifier: 'isSynchronizeActive',
      fn: this.isSynchronizeActive.bind(this)
    });
    this.formConfig.functions.push({
      identifier: 'setValuePyme',
      fn: this.setValuePyme.bind(this)
    });
    //Cargamos las funciones de permisos por perfiles
    this.formConfig.functions.push({
      identifier: 'userHasRoles',
      fn: this.userHasRoles.bind(this)
    });
    this.formConfig.functions.push({
      identifier: 'userHasRolesInApp',
      fn: this.userHasRolesInApp.bind(this)
    });

    this.formConfig.showValidations = true;
    this.formConfig.isModalWindow = true;
    this.formConfig.windowHash = this.windowHash;
    this.formConfig.searchTags = [HelpType.EDIT_COMPANY];
    this.formContainer.clear();


    const childComponent = this.componentFactoryResolver.resolveComponentFactory(
      formPlycaComponent
    );
    // at this point we want the "child" component to be rendered into the app.component:
    this.form = this.formContainer.createComponent(childComponent).instance;
    this.form['formConfig'] = this.formConfig;

    this.form['manageWaitService'] = false;
    this.subscribe(this.form.getCompleted().pipe(
      tap(
        (ok) => {
          if (ok) {

            this.waitService.cancelWaiting();
            this.loaded = true;


          }
        }

      ), finalize(() => {

      }),
      catchError((error: any) => {
        this.waitService.cancelWaiting();
        return throwError(error);
      })
    )

    )
  }

  userHasRoles(model: any, roles: string): boolean {
    if (!roles)
      return false;
    return this.userService.hasRoles(roles);
  }

  userHasRolesInApp(model: any, app: string): boolean {
    if (!app)
      return false;
    return this.userService.hasRolesInApp(app);
  }

  editMode() {
    this.editing = true;
    this.loadActionsEdit();
  }

  save() {

    let tmpExp: any;
    tmpExp = lodash.cloneDeep(this.companyDTO);
    this.companyService.viewModel2DTO(tmpExp);
    // limpiar variables de apoyo de tablas
    tmpExp = JSON.parse(
      JSON.stringify(tmpExp, (k, v) => (k === '_parent' ? undefined : v))
    );

    this.subscribe(this.companyService.save(tmpExp),
      (result: CompanyDTO) => {
        this.editing = false;
        //this.loadActionsInit();
        // marcar los campos como modificados y limpiar
        this.form.formGroup.markAsPristine();
        this.form.deleteFormErrors();
        console.log('this.ref .............')
        console.log(this.ref);

        // El update no devuelve resultado, el insert si

        if (result?.identifier) {
          this.companyDTO = result;
          this.companyService.dto2ViewModel(this.companyDTO);
          this.closeWindow();
        } else {
          this.subscribe(this.companyService.get(tmpExp).pipe(
            tap(response => {
              this.companyDTO = response;
              this.companyService.dto2ViewModel(this.companyDTO);
              this.closeWindow();
            }

            ), catchError((error: any) => {
              this.waitService.cancelWaiting();
              return throwError(error);
            })

          )

          );
        }
      }, err => {
        this.form.manageFormException(err);

      });
  }

  loadActionsInit() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.edit',
      'fas fa-pencil-alt',
      'btn btn-secondary',
      true, this.windowHash
    ),
      success => {
        this.editMode();
      });
  }

  loadActionsEdit() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    if (!this.readOnly)
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.save',
        'fas fa-lg fa-check',
        'btn btn-primary',
        true, this.windowHash
      ),
        success => {

          // com.nexusit.integraciones.terceros.logica.ConstantesIntegracionTerceros
          //SincronizacionTercerosActivo = "SincronizacionTerceros.Activo"
          //SincronizacionTercerosFraMtoEmpresaPublicarAlCrearTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlCrearTercero.Activo";
          //SincronizacionTercerosFraMtoEmpresaPublicarAlModificarTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlModificarTercero.Activo";
          //String SincronizacionTercerosFraMtoEmpresaPublicarAlEliminarTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlEliminarTercero.Activo";

          /*this.properties['SincronizacionTerceros_Activo'] = prop[0] == '1';
          this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlCrearTercero_Activo'] = prop[1] == '1';
          this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlModificarTercero_Activo'] = prop[2] == '1';
          this.properties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlEliminarTercero_Activo'] = prop[3] == '1';*/
          let showMessage = false;
          if (this.companyDTO['companyIntegrationProperties'] && this.companyDTO['companyIntegrationProperties']['SincronizacionTerceros_Activo']) {
            if (this.esAltaEmpresa && this.companyDTO['companyIntegrationProperties']
              && this.companyDTO['companyIntegrationProperties']['SincronizacionTerceros_FraMtoEmpresa_PublicarAlCrearTercero_Activo']) {
              showMessage = true;
            } else if (this.companyDTO['companyIntegrationProperties']
              && this.companyDTO['companyIntegrationProperties']['SincronizacionTerceros_FraMtoEmpresa_PublicarAlModificarTercero_Activo']) {
              showMessage = true;
            }
          }
          this.companyDTO.synchronize = false;
          if (showMessage) {
            //this.uiService.showConfirmMessage
            this.confirmationService.confirm({
              message: this.translateService.instant('CompanyAdmin.integration.sendData'),
              acceptLabel: this.translateService.instant('General.yes'),
              rejectLabel: this.translateService.instant('General.no'),
              accept: () => {
                this.companyDTO.synchronize = true; // Si hay integraci�n de terceros se sincronizar� la empresa con el sistema externo
                this.save();
              },
              reject: () => {
                this.save();
              }
            });
          } else {
            this.save();
          }
        });

    if (this.esAltaEmpresa) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-lg fa-times',
        'btn-outline-secondary',
        true, this.windowHash
      ),
        success => {
          this.closeWindow(true);
        });
    } else {
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.cancel',
        'fas fa-lg fa-times',
        'btn-outline-secondary',
        true, this.windowHash
      ),
        success => {
          this.closeWindow(true);
        });
    }
    setTimeout(() => {
      this.loaded = true;

    }, 500);

  }

  showErrors(err: any) {
    this.plycaErrorHandler.showServerError(err);
  }

  isEditing(): boolean {
    return !this.readOnly && this.editing;
  }

  isSynchronizeActive(): boolean {
    return this.companyDTO['companyIntegrationProperties'] ? this.companyDTO['companyIntegrationProperties']['SincronizacionTerceros_Activo'] : false;
  }

  closeWindow(cancel = false) {
    try {
      if (cancel) {
        this.ref.close();
      } else {
        // Se incluye el resultado para el elemento de formulario tye=COMPANY, que se entere del cambio
        this.ref.close(this.companyDTO);
      }

    } catch (e) {
      console.log(e);
    }
  }
  /* old
    cancelarEdicion() {
      this.editing = false;
      this.init();
      this.form.deleteFormErrors();
    }
  */
  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    // Al cerrar la modal se establece la ayuda de la pantalla origen
    // Para devolver la ayuda cuando se abre como modal
    // Lo control FORMPLYCA
    super.ngOnDestroy();

  }

  public isLoaded() {
    return this.loaded;
  }

  public setValuePyme() {
    if (this?.companyDTO?.customFields?.EMP_TIPO_PYME && this.companyDTO.customFields.EMP_TIPO_PYME.identifier) {
      let companyAux: any;
      companyAux = this.companyDTO;
      if (companyAux?.customFieldDefinitions?.EMP_TIPO_PYME && companyAux.customFieldDefinitions?.EMP_TIPO_PYME?.origin?.possibleValues) {

        const identificador = this.companyDTO.customFields.EMP_TIPO_PYME.identifier;

        // Buscar el elemento en "definiciones" que coincida con el identificador
        const pymeType = companyAux.customFieldDefinitions?.EMP_TIPO_PYME.origin?.possibleValues.find
          ((definicion) => definicion.identifier === identificador);

        if (pymeType?.properties && pymeType?.properties.PYME !== undefined) {
          this.companyDTO.customFields.EMP_ES_PYME_STD = {};
          if (pymeType?.properties.PYME === 0) {
            this.companyDTO.customFields.EMP_ES_PYME_STD.description = "No";
            this.companyDTO.customFields.EMP_ES_PYME_STD.identifier = "2<>nulo";
          } else if (pymeType?.properties.PYME === 1) {
            this.companyDTO.customFields.EMP_ES_PYME_STD.description = "Si";
            this.companyDTO.customFields.EMP_ES_PYME_STD.identifier = "1<>nulo";
          }
        }
      }

    }
  }
}
